/* @refresh reload */
import { render } from 'solid-js/web';
import './assets/styles.less';
import App from './App';
render(() => <App />, document.getElementById('root'));